import React from 'react';
import classnames from 'classnames';
import { Translate, withLocalize } from 'react-localize-redux';
import { writeErr } from '../common/logger';
import { apiGet, apiPost, getHostApi } from '../../store/apiWrapper';
import { Circles } from '../common/loadingComponent';
import Message from '../common/message';
import ModalInner from '../layoutItems/modalInner';
import RichTextEditor from "../common/richTextEditor";
import { Formik, Form } from 'formik';
import ReactHtmlParser from 'react-html-parser';

class AlertsNotesPopup extends React.Component {
    state = {
        isLoading: false,
        showConfirmDialog: false,
        error: null,
        noteId: null,
        createdAtFormatted: null,
        createdBy: null,
        updatedAt: null,
        updatedAtFormatted: null,
        updatedBy: null,
        note: "",
        success: "",
        error: "",
        update: false,
        deleted: false
    }

    colWidth = 200;
    rowHeight = 40;

    render() {
        return (
            <ModalInner close={() => this.props.close()} title={this.props.translate("Alerts.Notes.Popup.Header")}>
                {this.state.isLoading && <Circles />}
                {!this.state.isLoading && this.state.error && this.state.error.exception && <Message type="error" options={{ renderInnerHtml: true }}
                    message={this.props.translate(this.state.error.exception, this.getExceptionData(this.state.error.exceptionData))} />}

                {!this.state.isLoading && this.state.success && <Message type="success" options={{ renderInnerHtml: true }}
                    message={this.props.translate(this.state.success)} />}

                {!this.state.isLoading && this.state.error && <Message type="error" options={{ renderInnerHtml: true }}
                    message={this.props.translate(this.state.error)} />}

                {!this.state.isLoading && !this.state.deleted && <>
                    {this.state.noteId && <div style={{ display: "flex", flexDirection: "column", fontSize: "0.8em", textAlign: "right", margin: "1em" }}>
                        <span>
                            <Translate id="Alerts.Notes.Created" />
                            :&nbsp;
                            <span style={{ fontWeight: "600" }}>
                                {this.state.createdAtFormatted} ({this.state.createdBy})
                            </span>
                        </span>
                        {this.state.updatedAt &&
                            <span>
                                <Translate id="Alerts.Notes.Updated" />
                                :&nbsp;
                                <span style={{ fontWeight: "600" }}>
                                    {this.state.updatedAtFormatted} ({this.state.updatedBy})
                                </span>
                            </span>
                        }
                    </div>}
                    {!this.props.isReader &&
                        <Formik
                            onSubmit={(values, { setSubmitting }) => this.handleSubmit(values, setSubmitting)}>
                            {({
                                values,
                                setFieldValue
                            }) => (
                                <Form>

                                    <div className="ml-feedback-popup">
                                        <RichTextEditor
                                            value={this.state.note}
                                            onChange={(value) => this.updateContent(value)}
                                        />

                                    </div>
                                    <div className="modal-inner-buttons" style={{ marginBottom: "1em" }}>
                                        <button type="submit" disabled={this.state.loading || this.state.sending} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id={`${this.state.sending ? "Common.Sending" : this.state.update ? "Alerts.Notes.Update.Btn" : "Alerts.Notes.Create.Btn"}`} /></button>
                                        <button type="button" disabled={this.state.loading || !this.state.update || this.state.sending} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.deleteNote()}><Translate id={'Alerts.Notes.Delete.Btn'} /></button>
                                    </div>
                                </Form>
                            )}
                        </Formik>}
                    {this.props.isReader &&
                        <p>{ReactHtmlParser(this.state.note)}</p>
                    }
                </>}
            </ModalInner>
        )
    }

    componentDidMount() {
        if (this.props.noteId) {

            this.setState({
                isLoading: true,
                noteId: this.props.noteId,
                update: true
            });

            apiGet(`${getHostApi()}/api/portfolio/notes/${this.props.noteId}`, null,
                (s) => {

                    this.setState({
                        isLoading: false,
                        note: s.data.note,
                        createdBy: s.data.createdBy,
                        createdAtFormatted: s.data.createdAtFormatted,
                        updatedAtFormatted: s.data.updatedAtFormatted,
                        updatedBy: s.data.updatedBy,
                        updatedAt: s.data.updatedAt,
                        success: s.data.success,
                        error: s.data.error,
                        deleted: s.data.error ? true : false
                    });

                },
                (e) => writeErr(e)
            );
        }
    }

    deleteNote = () => {
        if (this.state.noteId) {
            this.setState({ sending: true });
            apiPost(`${getHostApi()}/api/portfolio/notes/${this.state.noteId}/delete`, null,
                {
                    updatedAt: this.state.updatedAt
                },
                (s) => {

                    this.setState({
                        sending: false,
                        note: s.data.note,
                        createdBy: s.data.createdBy,
                        createdAtFormatted: s.data.createdAtFormatted,
                        updatedAtFormatted: s.data.updatedAtFormatted,
                        updatedBy: s.data.updatedBy,
                        updatedAt: s.data.updatedAt,
                        success: s.data.success,
                        error: s.data.error,
                        deleted: true
                    });

                    this.props.editNotes(this.props.portfolioId, this.props.alertId, s.data)

                },
                _ => {
                    this.setState({ error: true, sending: false });
                }
            );
        }
    }

    updateContent(value) {
        this.setState({ note: value })
    }

    handleSubmit(values) {
        this.setState({ sending: true });
        if (this.state.note.length >= 6000) {
            this.setState({
                sending: false,
                error: 'Alerts.Notes.Error.NoteToLong',
            });
        } else {
            if (this.state.noteId) {
                apiPost(`${getHostApi()}/api/portfolio/notes/${this.state.noteId}/update`, null,
                    {
                        note: this.state.note,
                        updatedAt: this.state.updatedAt
                    },
                    (s) => {

                        this.setState({
                            sending: false,
                            note: s.data.note,
                            createdBy: s.data.createdBy,
                            createdAtFormatted: s.data.createdAtFormatted,
                            updatedAtFormatted: s.data.updatedAtFormatted,
                            updatedBy: s.data.updatedBy,
                            updatedAt: s.data.updatedAt,
                            success: s.data.success,
                            error: s.data.error,
                            noteId: s.data.noteId
                        });

                    },
                    _ => {
                        this.setState({ error: true, sending: false });
                    }
                );
            }
            else {
                apiPost(`${getHostApi()}/api/portfolio/notes/create`, null,
                    {
                        note: this.state.note,
                        alertId: this.props.alertId,
                        portfolioId: this.props.portfolioId
                    },
                    (s) => {

                        this.setState({
                            sending: false,
                            note: s.data.note,
                            createdBy: s.data.createdBy,
                            createdAtFormatted: s.data.createdAtFormatted,
                            updatedAtFormatted: s.data.updatedAtFormatted,
                            updatedBy: s.data.updatedBy,
                            updatedAt: s.data.updatedAt,
                            success: s.data.success,
                            error: s.data.error,
                            noteId: s.data.noteId,
                            update: true
                        });

                        this.props.editNotes(this.props.portfolioId, this.props.alertId, s.data)

                    },
                    _ => {
                        this.setState({ error: true, sending: false });
                    }
                );
            }
        }
    }
}

export default withLocalize(AlertsNotesPopup);